import React from 'react';
import './GradientBar.css';

export interface GradientBarProps {
  className?: string;
  style?: React.CSSProperties;
}

export const GradientBar: React.FC<GradientBarProps> = ({ className, style }) => (
  <div
    className={`hi-ui hi-ui-gradient-bar ${className || ''}`.trim()}
    style={style}
    aria-hidden="true"
  />
);
